module.exports = __webpack_public_path__ + "static/media/4_Hd.672889e1.png";